import { useTranslation } from 'libs/i18n'
import { ContextMenu } from 'shared/components'
import { Detail } from 'shared/atoms'
import type { Option } from 'shared/components/ContextMenu/types'
import type { TypeItem } from '../../types/types.types'

export type TypeProps = {
	productType: TypeItem
	menuOptions: Option[]
}

export const Type = ({ productType, menuOptions }: TypeProps) => {
	const { t } = useTranslation()

	return (
		<li className="p-4">
			<div className="flex items-start justify-between gap-3">
				<p className="min-w-0 text-[13px] font-semibold text-foreground">{productType.name}</p>
				<ContextMenu
					dataId={productType.id}
					item={productType}
					options={menuOptions}
					label={t('Actions for {{ name }}', { name: productType.name })}
				/>
			</div>
			<dl className="mt-2 grid grid-cols-2 gap-x-4 gap-y-2 text-[11px]">
				<Detail label={t('Products')} value={productType.products_count} />
			</dl>
		</li>
	)
}
